import { useTranslation } from 'react-i18next';
import useSWR from 'swr';
import { InfoIcon } from '@phosphor-icons/react';
import { I18nNamespace } from '@/lib/i18n-namespaces';
import { AdminSettingsService } from '@/services/engine/admin-settings-service';
import { IntegrationsTabSkeleton } from './IntegrationsTabSkeleton';
import { IntegrationRow } from './IntegrationRow';
import type { IntegrationsResponse } from '@/types/admin-settings';

const CACHE_KEY = 'admin-integrations';

export function IntegrationsTab() {
    const { t } = useTranslation(I18nNamespace.SETTINGS);
    const { data, isLoading, error } = useSWR<IntegrationsResponse>(
        CACHE_KEY,
        () => AdminSettingsService.getIntegrations(),
        { revalidateOnFocus: false },
    );

    if (isLoading) {
        return <IntegrationsTabSkeleton />;
    }

    if (error || !data) {
        return (
            <div className="border border-danger-300 rounded-[5px] p-4 text-danger-200 text-sm">
                {t('integrations.loadFailed')}
            </div>
        );
    }

    return (
        <div className="flex flex-col gap-6 pt-14 pb-24">
            <div className="flex items-start gap-2 p-3 rounded-md border border-grey-600 bg-grey-700/40">
                <InfoIcon className="size-4 text-grey-300 shrink-0 mt-0.5" />
                <p className="text-sm text-grey-200">
                    {t('integrations.readOnlyNotice')}
                </p>
            </div>

            <div className="flex flex-col gap-2">
                {data.integrations.map((integration) => (
                    <IntegrationRow
                        key={integration.key}
                        integration={integration}
                    />
                ))}
            </div>
        </div>
    );
}
